import script from "./ActionInspector.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionInspector.vue?vue&type=script&setup=true&lang=js"

import "./ActionInspector.vue?vue&type=style&index=0&id=0255c35e&lang=scss"

const __exports__ = script;

export default __exports__